import { PLANT_CATEGORIES } from './plantCategories';
import { sortByCommonName } from './plantCatalogue';

/**
 * The catalogue as shelves (SPEC-011 D-2).
 *
 * One rail per category, in the FR-04 registry's order — never the data's. A
 * shelf list that re-sorts itself by how many plants happen to be in a category
 * moves under the user's thumb between content releases, which is the same
 * argument `plantCategories.js` makes about the filter row.
 *
 * A category with nothing left in it produces no shelf at all. That is what makes
 * the rails survive filtering: narrowing to "sharply drained" should leave three
 * shelves, not eight, five of which are empty rectangles (source spec §12).
 */
export function buildCategoryRails(plants, { languageCode = 'en' } = {}) {
    return PLANT_CATEGORIES
        .map((category) => ({
            ...category,
            plants: sortByCommonName(
                plants.filter((plant) => plant.category === category.key),
                languageCode,
            ),
        }))
        .filter((rail) => rail.plants.length > 0);
}
